import TariffSelect from './TariffSelect';

export default TariffSelect;
